import { useQuery } from '@tanstack/react-query';
import UserContent from "./UserContent";
import { userService } from '../../service/firebase/userService';

const User = () => {
  // 유저 목록 조회
  const { data: users = [], isLoading, error } = useQuery({
    queryKey: ['users'],
    queryFn: () => userService.getAll(),
  });

  return (
    <UserContent 
      users={users}
      loading={isLoading}
      error={error?.message || null}
    />
  );
};

export default User;